<template>
  <div>
    <SearchArea />
    <div class="px-5 md:px-0 md:w-95 mx-auto max-w-max">
      <BannerSection class="pb-10" />
      <TickerSection class="lg:mb-10" />
      <CompanyValues class="hidden md:block py-10 border-t border-b" />
      <CategoriesSection class="pt-10" />
      <TrendingProductsSection class="pt-10" />
      <GlobalCompanies class="hidden md:block py-10 border-t"/>
      <CompanyValues class="md:hidden py-10 border-t border-b mb-5" />
      <div v-if="!isUserLoggedIn" class="md:hidden flex pb-5">
        <div class="w-1/2">
          <img class="mb-3 mx-auto" src="@/assets/images/CartIcon.png">
          <div @click="setAuthTabModal(2)">
            <div class="text-center">
              Buy on BuyHive?
            </div>    
            <div class="text-center text-blueReg font-bold">
              Register Now
            </div>
          </div>
        </div>
        <div class="w-1/2">
          <img class="mb-3 mx-auto" src="@/assets/images/dollar.png">
          <a href="https://portal.thebuyhive.com/register/supplier" class="block">
            <div class="text-center">
              Sell on BuyHive
            </div>    
            <div class="text-center text-yellowReg font-bold">
              Register Now
            </div>
          </a>
        </div>
      </div>
      <GlobalCompanies class="md:hidden border-t py-10"/>
      <div class="pt-10 md:flex mb-12 md:mb-32">
        <div class="md:w-1/2">
          <img
            src="@/assets/images/buyHomeMask.png"
            class="hidden md:block rounded-t-lg md:rounded-l-lg md:rounded-t-none h-full"
          >
          <img
            src="@/assets/images/buyHomeMaskPhone.png"
            class="md:hidden rounded-t-lg md:rounded-l-lg md:rounded-t-none h-full w-full"
          >
        </div>
        <div class="md:w-1/2 bg-dark text-center py-12 md:px-12 text-white rounded-b-lg md:rounded-r-lg md:rounded-b-none">
          <p>Looking for a custom item?</p>
          <p class="text-xl mt-2">Contact our sales <br> team today</p>
          <router-link
            to="/contact-us"
            class="bg-green inline-block px-6 py-2 rounded-full mt-4"
          >
            Get a Custom Quote
          </router-link>
        </div>
      </div>
    </div>
    <CovidBanner />
    <!-- <SurveyPopUp v-if="surveyModal" @close="closeTicker" /> -->
  </div>
</template>

<script>
import SearchArea from '@/shared/components/layout/SearchArea'
import BannerSection from '@/shared/components/home/BannerSection'
import CompanyValues from '@/shared/components/home/CompanyValues'
import TrendingProductsSection from '@/shared/components/home/TrendingProductsSection'
import CategoriesSection from '@/shared/components/home/CategoriesSection'
import CovidBanner from '@/shared/components/shared/CovidBanner' 
import TickerSection from '@/shared/components/home/TickerSection.vue'
import GlobalCompanies from '@/shared/components/home/GlobalCompanies.vue'
import { mapActions, mapGetters } from 'vuex'
// import SurveyPopUp from '@/shared/components/home/SurveyPopUp.vue'
import Cookies from 'js-cookie'

export default {
  name: 'BuyHome',
  components: {
    SearchArea,
    BannerSection,
    CompanyValues,
    TrendingProductsSection,
    CategoriesSection,
    CovidBanner,
    TickerSection,
    GlobalCompanies
    // SurveyPopUp
  },
  computed:{
    ...mapGetters ([
      'isUserLoggedIn'
    ]),
  },
  data () {
    return {
      surveyModal: false,
    }
  },
  methods: {
    ...mapActions ([
      'setAuthTabModal'
    ]),
    closeTicker(){
      Cookies.set("isSurveyDone", "true", { expires: 180 })
      this.surveyModal = false
    }
  },
  // mounted(){
  //   if (Cookies.get("isSurveyDone") == undefined) Cookies.set("isSurveyDone", "false", { expires: 180 })
  //   let survey = Cookies.get("isSurveyDone")
  //   if ( survey == "false" && !this.isUserLoggedIn ) {
  //     setTimeout( ()=> {
  //       this.surveyModal = true
  //     }, 20000)
  //   }
  // }
}
</script>
